<template>
  <div>
    <v-layout row wrap>
      <v-flex xs12>
        <v-layout
                my-1
                align-center
        >
          <strong class="mx-4 info--text text--darken-3">
            <a href="#" @click.prevent="changeTranslated(null)">Total: {{ stats.total }}</a>
          </strong>

          <v-divider vertical></v-divider>

          <strong class="mx-4 info--text text--darken-3">
            <a href="#" @click.prevent="changeTranslated(false)">Remaining: {{ stats.remaining }}</a>
          </strong>

          <v-divider vertical></v-divider>

          <strong class="mx-4 black--text">
            <a href="#" @click.prevent="changeTranslated(true)">Translated: {{ stats.translated }}</a>
          </strong>
        </v-layout>
      </v-flex>
      <v-flex xs6 sm4 d-flex>
        <v-select
                :items="categories"
                v-model="categoryId"
                item-text="fullName"
                item-value="id"
                placeholder="All categories"
                clearable
                label="Category"
        ></v-select>
      </v-flex>
      <v-flex offset-sm4 xs6 sm4 d-flex>
        <v-text-field
                label="Search"
                append-icon="search"
                v-model="search"
        ></v-text-field>
      </v-flex>
    </v-layout>
    <v-data-table
            :headers="headers"
            :items="translations"
            :loading="isLoading"
            :pagination.sync="pagination"
            :total-items="pagination.totalItems"
            :rows-per-page-items='[25,50,{"text":"All","value":-1}]'
            disable-initial-sort
            class="elevation-1"
    >
      <template slot="items" slot-scope="props">
        <td class="justify-center"><RowImage :src-set="props.item.translation.imageSet" :backup-set="props.item.imageSet" /></td>
        <td class="text-xs-left">{{ props.item.text }}</td>
        <td class="text-xs-left">
          <span v-if="props.item.translation.text">{{ props.item.translation.text }}</span>
          <span class="red--text" v-if="!props.item.translation.text">no translation</span>
        </td>
        <td class="text-xs-left">
          <Example v-for="example in props.item.translation.examples" :value="example" :key="example.id"></Example>
        </td>
        <td class="justify-center layout px-0">
          <v-icon
                  small
                  class="mr-2"
                  @click="$emit('edit', props.item)"
          >
            edit
          </v-icon>
        </td>
      </template>
      <template slot="no-data">
        <v-alert :value="errorOnLoad" color="error">
          Произошла ошибка при получении данных :(
        </v-alert>
        <div v-if="!errorOnLoad">No data</div>
      </template>
    </v-data-table>
  </div>

</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { FETCH_TRANSLATIONS } from '../store/action-types'
import debounce from 'lodash/debounce'
import RowImage from './RowImage'
import Example from './Example'

export default {
  components: { Example, RowImage },
  data () {
    return {
      categoryId: null,
      search: null,
      pagination: { page: 1 },
      translated: null,

      headers: [
        { text: 'Image', value: 'image', sortable: false },
        { text: 'Word', value: 'text', sortable: false },
        { text: 'Translation', value: 'translation.text', sortable: false },
        { text: 'Examples', value: 'translation.examples', sortable: false },
        { text: 'Actions', value: 'id', sortable: false }
      ]
    }
  },
  computed: {
    params () {
      return {
        search: this.search,
        categoryId: this.categoryId,
        page: this.pagination.page,
        rowsPerPage: this.pagination.rowsPerPage,
        sortBy: 'position',
        descending: this.pagination.descending,
        translated: this.translated
      }
    },
    stats () {
      return this.dictionary.stats || {}
    },
    ...mapState([
      'dictionary',
      'translations',
      'errorOnLoad',
      'totalWords',
      'categories'
    ]),
    ...mapGetters([
      'isLoading'
    ])
  },
  watch: {
    dictionary (cur, prev) {
      if (prev !== null) {
        this.pagination.page = 1
        this.debouncedFetchWords()
      }
    },
    totalWords () {
      this.pagination.totalItems = this.totalWords
    },
    categoryId () {
      this.pagination.page = 1
      this.debouncedFetchWords()
    },
    search () {
      this.pagination.page = 1
      this.debouncedFetchWordsForTyping()
    },
    params: {
      handler () {
        this.debouncedFetchWords()
      },
      deep: true
    }
  },
  created () {
    this.debouncedFetchWords = debounce(this.fetchWords, 100)
    this.debouncedFetchWordsForTyping = debounce(this.fetchWords, 800)
    this.debouncedFetchWords()

    this.pagination = {
      page: (this.$route.query.page || 1) * 1,
      rowsPerPage: (this.$route.query.rowsPerPage || 25) * 1,
      sortBy: this.$route.query.sortBy,
      descending: this.$route.query.descending,
      totalItems: (this.$route.query.totalItems || this.totalWords) * 1
    }
    this.categoryId = this.$route.query.categoryId
    this.search = this.$route.query.search
  },
  methods: {
    async fetchWords () {
      await this.$store.dispatch(FETCH_TRANSLATIONS, { ...this.params })
    },
    changeTranslated (val) {
      this.translated = val
    }
  }
}
</script>
